import React, { useState, useEffect } from 'react';
import FashionDesignCompany from './components/FashionDesignCompany';
import ComprehendYourStyle from './components/ComprehendYourStyle';
import StylishMaterials from './components/StylishMaterials';
import YoutubeVideo from './components/YoutubeVideo';
import CustomMade from './components/CustomMade';
import Comprehensivedesign from './components/Comprehensivedesign';
import Blog from './components/Blogs';
import FeaturesSection from './components/Services';
import InstagramInfo from './components/InstagramInfo';
import Review from './components/Review';
import CarouselComponent from '../About/components/CarouselComponent';
import { Box, CircularProgress } from '@mui/material';
import axios from 'axios';

// 🖼️ Banner images
const images = [
  '/images/Banner/banner.jpg',
  '/images/Comprehensivedesign/inner-section-right-img.jpg',
  '/images/Banner/banner.jpg',
];

// 🔁 Auto-fading Banner Slider
const BannerSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '60vh', sm: '100vh' },
        mt: { sm: '0px', xs: 11 },
        overflow: 'hidden',
      }}
    >
      {images.map((img, index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: currentIndex === index ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            zIndex: currentIndex === index ? 1 : 0,
          }}
        />
      ))}
    </Box>
  );
};


// 🌐 Main Component
const Home = () => {
  const totalSections = 1; // For loading screen
  const [loadedSections, setLoadedSections] = useState(0);
  const [AllProduct, setAllProduct] = useState([]);
  const [AllClothProduct, setAllClothProduct] = useState([]);

  const loading = loadedSections < totalSections;

  // ✅ Increment when section is loaded
  const handleSectionLoaded = () => {
    setLoadedSections(prev => prev + 1);
  };

  // 📦 Fetch all products
  const fetchAllProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?page=1&limit=6`);
      setAllProduct(response.data.data);
    } catch (error) {
      console.error('Error fetching all products:', error);
    } finally {
      handleSectionLoaded();
    }
  };

  // 📦 Fetch grouped cloth-type products
  const fetchAllClothProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/grouped-latest-products`);
      setAllClothProduct(response.data.data);
    } catch (error) {
      console.error('Error fetching cloth products:', error);
    } finally {
      handleSectionLoaded();
    }
  };

  // 🚀 Initial fetch
  useEffect(() => {
    fetchAllProducts();
    fetchAllClothProducts();
  }, []);

  return (
    <>
      {/* 🔃 Loading Screen */}
      {loading && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          backgroundColor: '#000000cc',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <CircularProgress size={70} thickness={4.5} sx={{ color: '#BB9D7B' }} />
        </Box>
      )}

      {/* 🎞️ Auto-Fading Banner Slider */}
      <BannerSlider />

      {/* 🎨 Sections */}
      <StylishMaterials onLoaded={handleSectionLoaded} AllProduct={AllProduct} />
      <YoutubeVideo />
      <CustomMade onLoaded={handleSectionLoaded} AllProduct={AllClothProduct.slice(0, 3)} />
      <Comprehensivedesign onLoaded={handleSectionLoaded} AllProduct={AllClothProduct.slice(3, 6)} />
      <Review />
      <Blog />
      <FeaturesSection />
      <CarouselComponent />
      {/* <InstagramInfo /> */}
    </>
  );
};

export default Home;
